import * as actionTypes from './actionTypes';

const initialState = {
  referDetails: []
}

const reducer = (state = initialState, action) => {
  // console.log(action)
  switch (action.type) {
    case actionTypes.UPDATE_REFER:
      state = {
        ...state,
        referDetails: action.payload,
      }
      break;
    default:
      state = { ...state };
      break;

  }
  // console.log(state);
  return state;
}

export default reducer;